
<template>
  <v-dialog
    v-model="dialog"
    scrollable
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
    @keydown.esc="closeDialog"
  >
    <v-card>
      <v-toolbar dark color="primary" max-height="60">
        <v-btn icon dark @click="closeDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <small>{{ $i18n.t("Vehicle") }}</small>
      </v-toolbar>
      <v-card-text>
        <vehicles
          :singlePage="true"
          :showGrid1="showGrid1"
          :bodyType="bodyType"
          :truckType="truckType"
          @select="select"
          @closeDialog="closeDialog"
          :showClose="true"
          :showSelectBtn="true"
        />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { Vue, Component, Watch } from "vue-property-decorator";
import Vehicles from "@/views/vehicle/Vehicles.vue";

@Component({
  name: "VehicleCreate",
  components: {
    Vehicles,
  },
  props: {
    showDialog: {
      default: false,
    },
    bodyType: {
      default: null,
    },
    truckType: {
      default: null,
    },
    showGrid1: {
      default: false,
    },
  },
})
export default class VehicleCreate extends Vue {
  dialog = false;

  hideMe() {
    this.$emit("dialogUpdate", false);
  }

  @Watch("showDialog")
  onShowDialogChange(val) {
    this.dialog = val;
  }

  closeDialog() {
    this.dialog = false;
    this.$emit("select", null);
  }

  select(data) {
    this.$emit("select", data);
  }
}
</script>
